import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import AppDialog from '../AppDialog';

export default function InformationDialog(props) {
    const { open, title, text, close } = props;

    return (
        <AppDialog
            open={open}
            onClose={close}
            title={title}
            onSubmit={close}
            submitText='Ok'
            hideCancel
        >
            <Typography>{text}</Typography>
        </AppDialog>
    );
}

InformationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
};